import { localize } from '../i18n';

// Only the app's initial greeting is interface copy. Keep user messages and
// stored AI replies in their original language and preserve the stored greeting.
export function displayChatMessage(message, initialGreeting) {
    if (message.role !== 'user' && message.content === initialGreeting) return localize(initialGreeting);
    return message.content;
}
